export function formatTime(timestamp: string): string {
  const date = new Date(timestamp);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
}

export function validateFileType(filename: string): boolean {
  const ext = filename.split('.').pop()?.toLowerCase();
  const allowedTypes = ['pdf', 'docx', 'txt'];
  return ext ? allowedTypes.includes(ext) : false;
}

export function validateFileSize(file: File): boolean {
  const maxSize = 10 * 1024 * 1024;
  return file.size <= maxSize;
}